export const MAX_SELECTED_THREADS_NUMBER = 15;
